import React, { useEffect } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import Str from "shared/components/Str";
import DisplayAd from "shared/components/DisplayAd";
import { FORMATS_KEYS } from "shared/modules/onpageads/constants";
import "shared/modules/onpageads";

import "./index.scss";

const goodbyeAd = [
	{
		name: "Match - guy",
		seenHash: "zpu0Xmw38N5THau6x1ekSFqSc2w=",
		clickedHash: "HadO7mOo8CGCGuHe5mF1J9olEwo=",
		class: "guy",
		link: "http://www.match.com/en-us/landing/display/srch/52038.html?tr=1&trackingid=526578&bannerid=729235",
	},
	{
		name: "Match - girl",
		seenHash: "gUSXXDPquBc6xH76KJGFZ72MiGM=",
		clickedHash: "ooML11XiOapIuvwCgkpr5iWZO3M=",
		class: "girl",
		link: "http://www.match.com/en-us/landing/display/srch/52038.html?tr=2&trackingid=526578&bannerid=729236",
	},
][Math.round(Math.random())];

const Logout = ({ location }) => {
	const queryParams = queryString.parse(location.search);
	const isDeleteDisablePage = !!queryParams.delete || queryParams.disable;
	const isGoodbyePage = isDeleteDisablePage || !!queryParams.goodbye;
	const accountStatus = queryParams.delete
		? _str("deleted")
		: _str("disabled");

	useEffect(() => {
		if (!window.util || !isGoodbyePage) {
			return;
		}

		window.util.updateStats("account deletion - saw competitor ad", 1, "counter", "/mzmXLP/6nFmpYMgqiUfGSRsVFk=");
		window.util.updateStats(`account deletion - saw competitor ad - ${goodbyeAd.name}`, 1, "counter", goodbyeAd.seenHash);
	}, [isGoodbyePage]);
	const onGoodbyeAdClick = () => {
		if (!window.util) {
			return;
		}

		window.util.updateStats(
			`account deletion - clicked competitor ad – ${goodbyeAd.name}`,
			1,
			"counter",
			goodbyeAd.clickedHash,
			{ "redirect_to": goodbyeAd.link },
		);
	};

	return (
		<React.Fragment>
			<div id="header">
				<div id="header_content">
					<p id="logo">
						<a href="/">OkCupid.com: Free Online Dating</a>
					</p>
					<div id="user_header" className="logged_out">
						{!isDeleteDisablePage && (
							<div className="message">
								{_str("You’re now signed out of OkCupid.")}
							</div>
						)}

						<a id="open_sign_in_button" className="flatbutton hollow" href="/login">
							{_str("Sign in")}
						</a>
					</div>
				</div>
			</div>
			{isDeleteDisablePage ? (
				<div className="banner full_width red centered">
					<div className="banner_inner content_container">
						<h2 className="message">
							{_strf("Your account has been $accountStatus.", { accountStatus })}
						</h2>
					</div>
				</div>
			) : (
				<div className="banner full_width logout_mobile_banner">
					<div className="banner_inner content_container">
						<div className="mobile_icons" />
						<h2 className="message">
							{_str("You signed out, but we don’t have to be apart.")}
						</h2>
						<div className="buttons">
							<a id="ios_button" href="%{APP_STORE_CAMPAIGNS['okcupid.com/logout']}" target="_blank">
								{_str("For iOS")}
							</a>
							<a id="android_button" href="%{PLAY_STORE_CAMPAIGNS['okcupid.com/logout']}" target="_blank">
								{_str("For Android")}
							</a>
						</div>
					</div>
				</div>
			)}

			<div id="ad_holder" className="content_container">
				<p>{_str("Advertisement")}</p>
				<div id="advert">
					{isGoodbyePage ? (
						<div id="goodbye" className="account_deleted">
							<div className="ad">
								<p>{_str("Why not try another great option?")}</p>
								<p className="link">
									{/* eslint-disable jsx-a11y/anchor-is-valid */}
									<a
										className={`ad_${goodbyeAd.class}`}
										href="#"
										onClick={onGoodbyeAdClick}>
										<Str>Match</Str>
									</a>
									{/* eslint-enable jsx-a11y/anchor-is-valid */}
								</p>
							</div>
						</div>
					) : (
						<div id="logout">
							<div className="ad-container">
								<DisplayAd format={FORMATS_KEYS.LOGOUT} />
							</div>
						</div>
					)}
				</div>
			</div>
		</React.Fragment>
	);
};

Logout.propTypes = {
	location: PropTypes.shape({
		search: PropTypes.string.isRequired,
	}).isRequired,
};

export default Logout;



// WEBPACK FOOTER //
// ./src/apps/logout/index.jsx